export const commonWebSocket = {
  snapshot: {
    FAMILY_DATA: 'FAMILY_DATA',
    FAMILY_SNAPSHOT: 'FAMILY_SNAPSHOT',
    CHATS_SNAPSHOT: 'CHATS_SNAPSHOT',
    SCHEDULES_SNAPSHOT: 'SCHEDULES_SNAPSHOT',
    SUGGESTIONS_SNAPSHOT: 'SUGGESTIONS_SNAPSHOT',
    AGREEMENTS_SNAPSHOT: 'AGREEMENTS_SNAPSHOT',
    EVENT_SNAPSHOT: 'EVENT_SNAPSHOT',
    TODO_SNAPSHOT: 'TODO_SNAPSHOT',
    EXPERT_SNAPSHOT: 'EXPERT_SNAPSHOT',
    OFFER_SNAPSHOT: 'OFFER_SNAPSHOT',
    RESOURCE_SNAPSHOT: 'RESOURCE_SNAPSHOT',
    SUBSCRIPTION_SNAPSHOT: 'SUBSCRIPTION_SNAPSHOT',
    SHARED_NOTE_ORDER_SNAPSHOT: 'SHARED_NOTE_ORDER_SNAPSHOT',
    ECO_SETTINGS_SNAPSHOT:'ECO_SETTINGS_SNAPSHOT',
    EXTERNAL_CALENDAR_SNAPSHOT: "EXTERNAL_CALENDAR_SNAPSHOT",
    RATINGS_SNAPSHOT: 'RATINGS_SNAPSHOT',
  },
  replace: {
    FAMILY_UPDATE: 'FAMILY_UPDATE',
    SCHEDULE_UPDATE: 'SCHEDULE_UPDATE',
    EVENT_UPDATE: 'EVENT_UPDATE',
    TODO_UPDATE: 'TODO_UPDATE',
    SUGGESTION_UPDATE: 'SUGGESTION_UPDATE',
    AGREEMENT_UPDATE: 'AGREEMENT_UPDATE',
    CALENDAR_SETTINGS: 'CALENDAR_SETTINGS',
    CHILD_INFO_UPDATE: 'CHILD_INFO_UPDATE',
    SHARED_NOTE_UPDATE: 'SHARED_NOTE_UPDATE',
    FLOW_POST_UPDATE: 'FLOW_POST_UPDATE',
    EXTERNAL_CALENDAR_UPDATE: "EXTERNAL_CALENDAR_UPDATE",
    CALLS:"CALLS",
    CALL_DATA:"CALL_DATA",
    STRICT_TOXIC_CHECK:"STRICT_TOXIC_CHECK",
    DARK_MODE:"DARK_MODE",
    AUTO_APPROVE_SUGGESTIONS:"AUTO_APPROVE_SUGGESTIONS",
  },
  special: {
    REQUEST_ID: 'REQUEST_ID',
    ERROR_MESSAGE: 'ERROR_MESSAGE',
    CHAT_UPDATE: 'CHAT_UPDATE',
    MESSAGE_READ_INFO: 'MESSAGE_READ_INFO',
    EVENT_UPDATE : 'EVENT_UPDATE',
    EVENT_ANALYZE_UPDATE : 'EVENT_ANALYZE_UPDATE',
    NEW_CHAT: 'NEW_CHAT',
    LOG_ENTRIES: 'LOG_ENTRIES',
    FILE_UPLOAD: 'UPLOAD_FILE',
    TODO_REMOVED: 'TODO_REMOVED',
    SHARED_NOTE_REMOVED:  'SHARED_NOTE_REMOVED',
    FLOW_POST_REMOVED: 'FLOW_POST_REMOVED',
    TOXIC_REPLY: 'TOXIC_REPLY',
    USER_TOKEN_UPDATE : 'USER_TOKEN_UPDATE',
    ECO_AGREEMENT_UPDATE: 'ECO_AGREEMENT_UPDATE',
    ECO_PURCHASE_UPDATE: 'ECO_PURCHASE_UPDATE',
    ECO_TRANSFER_UPDATE: 'ECO_TRANSFER_UPDATE',
    READ_ARTICLES_UPDATE : 'READ_ARTICLES_UPDATE',
    EXTERNAL_CALENDAR_DELETE: "EXTERNAL_CALENDAR_DELETE",
    AI_TASK: "AI_TASK",
    AI_SCHEDULE_UPDATE: "AI_SCHEDULE_UPDATE",
  }
};



// WEBPACK FOOTER //
// ./src/services/common/common.constants.ts